<template>
  <div>
    <ExternaAdd :dialog="dialog" :userType="userType" v-on:close="close()"  />
    <el-radio-group v-model="ruleForm.external" v-loading="loading" @change="update()">
      <el-radio-button v-for="record of tableData" :key="record.id" :label="record.id" :ref="record.id">
        <img v-if="record.content" :src="record.content" class="image-external" />
        <span v-else class="avatar-uploader-icon">{{ record.name }}</span>
      </el-radio-button>
    </el-radio-group>
    &nbsp;
    <el-button type="info" style="float: right" @click="add">Novo</el-button>
  </div>
</template>

<script>
import { ExternalService } from "@/services/customers/external.services";
import ExternaAdd from './ExternaAdd.vue';

export default {
  components: { ExternaAdd },
  name: "ExternalList",
  props: {
    userType: String,
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  }, 
  methods: {
    close() {
      const vm = this;
      vm.fetchRecords();
      vm.dialog = false;
    },
    add() {
      const vm = this;
      vm.dialog = true;
    },
    select(index) {
      const vm = this;
      if (vm.tableData[index]) {
        vm.ruleForm.external = vm.tableData[index].id;
        vm.$emit("selected", vm.ruleForm.external);
      }
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.list()
        .then((response) => {
          vm.tableData = response;
          setTimeout(() => {
            if (vm.tableData.length > 0 && this.$refs[vm.tableData[0].id] && this.$refs[vm.tableData[0].id].$el) {
              this.$refs[vm.tableData[0].id].$el.getElementsByTagName('input')[0].focus();
            }
          }, 200); 

        })
        .catch(() => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());


    },
    update() {
      const vm = this;
      vm.$emit("input", vm.ruleForm.external);
      vm.$emit("selected", vm.ruleForm.external);
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      dialog: false,
      ruleForm: {
        external: '',
      }
    };
  },
};
</script>
<style>
.image-external {
  width: 100px;
  height: 60px
}
</style>